var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 32.9996C20.0547 33.0316 17.6189 33.0167 15.1647 32.955C9.91722 32.8232 7.29347 32.7573 5.40826 30.8649C3.52304 28.9725 3.46856 26.4179 3.3596 21.3087C3.32457 19.6658 3.32457 18.0327 3.3596 16.3899C3.46856 11.2807 3.52303 8.72608 5.40825 6.8337C7.29347 4.94131 9.91721 4.87539 15.1647 4.74355C18.3988 4.6623 21.6012 4.66231 24.8353 4.74357C30.0828 4.87541 32.7065 4.94134 34.5917 6.83372C36.477 8.72611 36.5314 11.2807 36.6404 16.3899C36.6579 17.2113 36.6667 18.0303 36.6667 18.8493",
    stroke: "#337CC1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33316 8.84961L14.8549 15.3906C19.0643 17.7804 20.9354 17.7804 25.1448 15.3906L36.6665 8.84961",
    stroke: "#337CC1",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 27.1823C27.4857 26.3395 29.6661 23.0156 30.8332 23.0156M34.9998 27.1823C34.1806 26.3395 32.0002 23.0156 30.8332 23.0156M30.8332 23.0156V36.349",
    stroke: "#337CC1",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerification);
export default __webpack_public_path__ + "static/media/emailVerification.2fb6b88b6c27d4f5e40f80e008ffbc34.svg";
export { ForwardRef as ReactComponent };